import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ForeignerResidence from './foreigner-residence';
import ForeignerResidenceDetail from './foreigner-residence-detail';
import ForeignerResidenceUpdate from './foreigner-residence-update';
import ForeignerResidencePrint from './foreigner-residence-print';
import ForeignerResidenceDeleteDialog from './foreigner-residence-delete-dialog';

const ForeignerResidenceRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ForeignerResidence />} />
    <Route path="new" element={<ForeignerResidenceUpdate />} />
    <Route path=":id">
      <Route index element={<ForeignerResidenceDetail />} />
      <Route path="edit" element={<ForeignerResidenceUpdate />} />
      <Route path="print" element={<ForeignerResidencePrint />} />
      <Route path="delete" element={<ForeignerResidenceDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ForeignerResidenceRoutes;
